import * as React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Stack,
  Link,
} from "@mui/material";
import { AuthenticationContext } from "../Context";
import { useHistory } from "react-router-dom";
import { getHeaders } from "../utils/HeaderHelper";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { checkPrivileges } from "../utils/PrivilegesHelper";
import { PrivilegesContext } from "../PrivilegesContext";

const ActionsPrograms: React.FC = () => {
  const authenticationSetting = React.useContext(AuthenticationContext);
  const userPrivileges = React.useContext(PrivilegesContext);
  const history = useHistory();

  const [featureFlags, setFeatureFlags] = React.useState<any>("");

  React.useEffect(() => {
    getFeatureFlags();
  }, []);

  const getFeatureFlags = () => {
    fetch(`/feature_flags`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (!result.success) {
          console.log(result.message);
        } else {
          setFeatureFlags(result?.resource);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const settingsMenus = [
    {
      title: "Action Builder",
      description:
        "Create and customize the individual actions that make up your workflows. Define tasks, assign owners, and set triggers to guide patients through their care plans.",
      url: "action-builder-list",
      enabled: featureFlags?.FEATURE_ACTION_BUILDER_ON == "true",
      showDisabled: false,
    },
    {
      title: "Program Management",
      description:
        "Quickly manage patient participation across programs. Mass unassign or transfer groups of patients between programs to keep enrollments accurate and up to date.",
      url: "program-management",
      enabled: checkPrivileges(userPrivileges, "Access Program Management"),
      showDisabled: true,
    },
    {
      title: "Program Builder",
      description:
        "Design and manage complete programs by combining actions into structured care pathways. Set enrollment criteria, scheduling rules, and outcomes to deliver consistent care experiences.",
      url: "program-builder",
      enabled: featureFlags?.FEATURE_PROGRAM_BUILDER_ON == "true",
      showDisabled: false,
    },
  ];

  const handleRouteNavigation = (route) => {
    history.push(`/${route}`);
  };

  return (
    <div className="settings-index-container">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container"
      >
        <Grid item xs={12} md={12}>
          <div className="userAdminInformation">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="stretch"
              className="adminHeader"
            >
              <Grid item xs={12} md={6}>
                <Stack direction="row" columnGap="12px">
                  <Link
                    style={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                    }}
                    href={`/settings`}
                  >
                    <ArrowBackIosNewIcon
                      style={{
                        borderRadius: "3px",
                        padding: "8px",
                        color: "black",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        fontSize: "14px",
                      }}
                    />
                  </Link>
                  <h3>Settings - Actions & Programs</h3>
                </Stack>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="divider"></div>
        </Grid>

        <div className="settings-inner-container" style={{ width: "100%" }}>
          <Grid container spacing={3}>
            {settingsMenus.map((settingsMenu, index) => {
              if (settingsMenu.enabled) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index + 1}>
                    <Card
                      className="item-card"
                      onClick={() => handleRouteNavigation(settingsMenu.url)}
                    >
                      <CardContent className="card-content">
                        <Typography className="card-title">
                          {settingsMenu.title}
                        </Typography>
                        <Typography className="card-description">
                          {settingsMenu.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              }

              if (!settingsMenu.enabled && settingsMenu.showDisabled) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index + 1}>
                    <Card className="item-card-disabled">
                      <CardContent className="card-content">
                        <Typography className="card-title-disabled">
                          {settingsMenu.title}
                        </Typography>
                        <Typography className="card-description-disabled">
                          {settingsMenu.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              }

              return null;
            })}
          </Grid>
        </div>
      </Grid>
    </div>
  );
};

export default ActionsPrograms;
